import React, {useState} from "react";
import {
    Box,
    Button,
    Flex,
    HStack,
    Input,
    InputGroup,
    InputRightElement,
    Table,
    Tbody,
    Td,
    Th,
    Thead,
    Tr,
    useDisclosure,
    VStack,
} from "@chakra-ui/react";
import {AddIcon, SearchIcon} from "@chakra-ui/icons";
import AddPaymentModal from "./AddPaymentModal";
// import {DatePicker} from "@chakra-ui/react-date-picker";

const PaymentReportTable = ({selectedSchool}) => {
    const [fromDate, setFromDate] = useState(null);
    const [toDate, setToDate] = useState(null);
    const [searchQuery, setSearchQuery] = useState("");

    // Add Payment modal state; bump refreshKey after a save so the list reloads.
    const {isOpen, onOpen, onClose} = useDisclosure();
    const [refreshKey, setRefreshKey] = useState(0);

    const data = [
        {
            id: 1,
            paymentDate: "2024-12-01",
            amount: 1000,
            taxAmount: 100,
            totalAmount: 1100,
            voucherNumber: "VCH12345",
            paymentMethod: "Credit Card",
            status: "Completed",
        },
        {
            id: 2,
            paymentDate: "2024-12-05",
            amount: 2000,
            taxAmount: 200,
            totalAmount: 2200,
            voucherNumber: "VCH67890",
            paymentMethod: "Bank Transfer",
            status: "Pending",
        },
    ];

    const filteredData = data.filter(
        (item) =>
            (fromDate ? new Date(item.paymentDate) >= new Date(fromDate) : true) &&
            (toDate ? new Date(item.paymentDate) <= new Date(toDate) : true) &&
            item.voucherNumber.includes(searchQuery)
    );

    return (
        <Box w="100%" p={4}>
            {/* Header with Add Payment action. */}
            <Flex justify="space-between" align="center" mb={4} wrap="wrap" gap={3}>
                <Box fontSize="lg" fontWeight="semibold">Payments</Box>
                <Button colorScheme="blue" leftIcon={<AddIcon/>} onClick={onOpen}>
                    Add Payment
                </Button>
            </Flex>

            <AddPaymentModal
                isOpen={isOpen}
                onClose={onClose}
                selectedSchool={selectedSchool}
                onSaved={() => setRefreshKey((k) => k + 1)}
            />

            {/* Filters */}
            <HStack mb={4} spacing={4}>
                <VStack align="start">
                    <Box>From Date</Box>
                    {/*<DatePicker*/}
                    {/*    selected={fromDate}*/}
                    {/*    onChange={(date) => setFromDate(date)}*/}
                    {/*    placeholderText="Select Date"*/}
                    {/*/>*/}
                </VStack>
                <VStack align="start">
                    <Box>To Date</Box>
                    {/*<DatePicker*/}
                    {/*    selected={toDate}*/}
                    {/*    onChange={(date) => setToDate(date)}*/}
                    {/*    placeholderText="Select Date"*/}
                    {/*/>*/}
                </VStack>
                <InputGroup>
                    <Input
                        placeholder="Search by Payment Number"
                        value={searchQuery}
                        onChange={(e) => setSearchQuery(e.target.value)}
                    />
                    <InputRightElement pointerEvents="none">
                        <SearchIcon color="gray.400" />
                    </InputRightElement>
                </InputGroup>
                <Button colorScheme="blue" onClick={() => console.log("Search!")}>
                    Search
                </Button>
            </HStack>

            {/* Table — `key` remounts the list after a payment is saved. */}
            <Table key={refreshKey} variant="striped" colorScheme="gray">
                <Thead>
                    <Tr>
                        <Th>SN</Th>
                        <Th>Payment Date</Th>
                        <Th>Amount</Th>
                        <Th>Tax Amount</Th>
                        <Th>Total Amount</Th>
                        <Th>Voucher Number</Th>
                        <Th>Payment Method</Th>
                        <Th>Status</Th>
                    </Tr>
                </Thead>
                <Tbody>
                    {filteredData.map((item, index) => (
                        <Tr key={item.id}>
                            <Td>{index + 1}</Td>
                            <Td>{item.paymentDate}</Td>
                            <Td>{item.amount}</Td>
                            <Td>{item.taxAmount}</Td>
                            <Td>{item.totalAmount}</Td>
                            <Td>{item.voucherNumber}</Td>
                            <Td>{item.paymentMethod}</Td>
                            <Td>{item.status}</Td>
                        </Tr>
                    ))}
                </Tbody>
            </Table>
        </Box>
    );
};

export default PaymentReportTable;